$(function () {
    if ($("div#EnrolmentListCard").length > 0) {

        $.urlParam = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                .exec(window.location.search);

            return (results !== null) ? results[1] || 0 : false;
        }

        var ddval = $.urlParam('pagesize');
        $('#rowsSelect option[value="' + ddval + '"]').prop('selected', true);
        var ddval2 = $.urlParam('pgSzP');
        $('#rowsSelectp option[value="' + ddval2 + '"]').prop('selected', true);


        $('#ActiveEnrolmentDate').datetimepicker('options', {
            format: "YYYY-MM-DD",
            locale: jsLang + '-ca',
            keepOpen: false,
            defaultDate: false
        });

        $('#ActiveEnrolmentDate').keydown(function (e) {
            e.preventDefault();
        });

        $('#ActiveEnrolmentDate').on('change.datetimepicker', function (e) {
            navigate(jsPrefix, jsLang);
        });

        $('#selectedlicense').on('change', function () {

            navigate(jsPrefix, jsLang);
        });

        function navigate(prefix, lang) {

            var selectedLicense = $('#selectedlicense').val();

            if (prefix != "q") {
                x = prefix + "/" + lang + "/" + 'license/manageenrolment/enrolmentlist/' + jsOper + '/' + selectedLicense + "?"
                    + "ActiveDate=" + $('#ActiveEnrolmentDate').val();
            }
            else {

                x = "/" + lang + "/" + 'license/manageenrolment/enrolmentlist/' + jsOper + '/' + selectedLicense + "?"
                    + "ActiveDate=" + $('#ActiveEnrolmentDate').val();
            }

            location.href = x;
            //Perform your navigation
        }

        function navigateTransitional(prefix, lang) {

            var selectedLicense = $('#selectedlicense').val() == null || $('#selectedlicense').val() == "" ? "a" : $('#selectedlicense').val();
            //debugger;
            if ($("#returnurlvalue").val() != "") {
                selectedLicense = $('#licens').val();
            }

            if (prefix != "q") {
                var x = prefix + "/" + lang + "/" + 'license/manageenrolment/enrolmentlist/' + jsOper + '/' + selectedLicense + "?pagesize=" + $('#rowsSelect').val()
                    + "&showInactive=" + $('#showInactive').attr("data-value") + "&pageNumber=" + $('#pageNumber').val() + "&pgSzP=" + $('#rowsSelect').val()
                    + "&shwinactP=" + $('#shwinactP').attr("data-value") + "&pgNumP=" + $('#pgNumP').val();

                if ($("#returnurlvalue").val() != "") {
                    var y = "&returnUrl=";
                    x = x.concat(y, jsReturnUrl);
                }
            }
            else {


                var x = "/" + lang + "/" + 'license/manageenrolment/enrolmentlist/' + jsOper + '/' + selectedLicense + "?pagesize=" + $('#rowsSelect').val()
                    + "&showInactive=" + $('#showInactive').attr("data-value") + "&pageNumber=" + $('#pageNumber').val() + "&pgSzP=" + $('#rowsSelectp').val()
                    + "&shwinactP=" + $('#shwinactP').attr("data-value") + "&pgNumP=" + $('#pgNumP').val();
                if ($("#returnurlvalue").val() != "") {
                    var y = "&returnUrl=";
                    x = x.concat(y, jsReturnUrl);
                }
            }

            location.href = x;
            //Perform your navigation
        }
        // row click

    }
});